export default async function storageQuota(): Promise<number> {
    if (!('storage' in navigator)) {
        throw new Error(`No navigator.storage api, cannot query for quota`);
    }

    if (!('estimate' in navigator.storage)) {
        throw new Error(`No navigator.storage api, cannot query for quota`);
    }

    const estimate = await navigator.storage.estimate();

    if (!estimate.quota || !estimate.usage) {
        throw new Error(`No valid quota response form StorageManager`);
    }

    const freeSpace = estimate.quota - estimate.usage;

    return freeSpace;
}
